import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Factory } from "lucide-react";

const serviceData = {
  id: "transformation",
  title: "Postes de transformation",
  description: "Installation et maintenance de postes MT/BT et groupes électrogènes",
  icon: Factory,
  image: "/Postetransformation.jpg", // Updated path
  longDescription: [
    "Nous assurons l'installation, la maintenance et la modernisation de vos postes de transformation MT/BT. Notre expertise garantit la fiabilité et la sécurité de vos installations de transformation électrique.",
    "Nos équipes qualifiées interviennent sur tous types de postes de transformation, des plus simples aux plus complexes, en assurant une continuité de service optimale.",
  ],
  features: [
    "Installation de postes MT/BT",
    "Maintenance préventive et corrective",
    "Installation de groupes électrogènes",
    "Systèmes de protection électrique",
    "Tableaux généraux basse tension",
    "Monitoring et supervision",
  ],
  benefits: [
    "Continuité de service garantie",
    "Conformité aux normes de sécurité",
    "Maintenance planifiée",
    "Intervention d'urgence 24/7",
    "Expertise technique spécialisée",
  ],
};

const PostesTransformation = () => {
  return (
    <div className="-mt-20">
      <div className="mt-8">
        <ServiceTemplate service={serviceData} />
      </div>
    </div>
  );
};

export default PostesTransformation;
